<template>
    <div id="template"  ref="template">
      <!--  <div class="templateinfo"  v-for="(items,index) in  templateList" :key="index">
            <div class="templateinfonumber" v-show="count===true">
                <span>{{index+1}}</span>
            </div>
            <div class="templateinfonumber"
                 v-show="count===false"
            >
                <span @mouseenter="resortTemplate" class="my-handle"><img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px"/></span>
            </div>


            <div class="templateinfoName">
                <span>{{items.name}}</span>
            </div>


            <div class="templateinfoDescription">
                <div class="templateInfoDes">{{items.description}}</div>
            </div>


            <div class="templateinfoOperation">
                <div class="templateinfoOperationBtn">
                    <div class="btnRevise" v-if="items!==''" @click="reviseTemplate(items.id)"><img src="../../../assets/images/fieldmanage/rivese.png" style="height: 16px;width: 16px" @click="dialogFormVisible1 = true"/></div>
                    <div class="btnDelete">
                        <img src="../../../assets/images/fieldmanage/delBlue.png" style="width: 16px;height: 16px" @click="deleteClick(items.id,items._workOderCount)" v-if="items!==''" />
                        <el-dialog  :visible.sync="dialogFormVisible" title="删除模板" custom-class="templateDialog" :close-on-click-modal="false">

                            <div class="templateDialogDelText">您删除的<span style="font-size: 16px;font-weight: 600">{{deleteTemplateName}}</span>模板下有<span style="font-size: 16px;font-weight: 600">{{items._workOderCount}}</span>个工单，需要将这些工单移动至</div>
                                <el-select v-model="template" style="width: 100%;margin-bottom: 12px">
                                    <el-option
                                            v-for="item in selectOrderList"
                                            :value="item.id"
                                            :key="item.id"
                                            :label="item.name"
                                    ></el-option>
                                </el-select>

                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                                    <el-button type="danger" @click="deleteTemplate(items.id,items._workOderCount)">删 除</el-button>
                                </div>


                               &lt;!&ndash; <div>你确定删除<span style="font-weight: 600;font-size: 16px">{{items.name}}吗？</span></div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                                    <el-button type="danger" @click="deleteTemplate(items.id)">删 除</el-button>
                                </div>
                           &ndash;&gt;

                        </el-dialog>
                        <el-dialog  :visible.sync="dialogFormVisible2" title="删除模板" custom-class="templateDialog" :close-on-click-modal="false">

                            <div class="templateDialogDelText">您确定删除<span style="font-size: 16px;font-weight: 600">{{deleteTemplateName}}</span>吗？</div>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                                <el-button type="danger" @click="deleteTemplate2(items.id)">删 除</el-button>
                            </div>


                            &lt;!&ndash; <div>你确定删除<span style="font-weight: 600;font-size: 16px">{{items.name}}吗？</span></div>
                             <div slot="footer" class="dialog-footer">
                                 <el-button @click="dialogFormVisible = false">取 消</el-button>
                                 <el-button type="danger" @click="deleteTemplate(items.id)">删 除</el-button>
                             </div>
                        &ndash;&gt;

                        </el-dialog>
                    </div>
                </div>
            </div>
        </div>-->
        <div class="module-result-content2">
            <div class="result-content2">
                <el-table
                        :data="templateList"
                        width="100%"
                        height="calc(100vh - 135px)"
                        :header-cell-style="{fontSize:'14px', fontWeight:'500'}"
                        :row-style="{fontSize:'14px',cursor:'pointer'}"
                        row-key="id"
                        :row-class-name="getRowClass"
                >
                    <el-table-column
                            type="index"
                            :index="indexMethod"
                            label="顺序"
                            width="100"
                            style="margin-left: 50px"
                            align="center"
                    >
                        <template scope="scope">
                            <div class="templateinfonumber" v-show="count===true">
                                <span>{{scope.$index+1}}</span>
                            </div>
                            <div class="templateinfonumber"
                                 v-show="count===false"
                            >
                                <span @mouseenter="resortTemplate" class="my-handle"><img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px"/></span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="模板名称"
                            align="left"
                            width="170"
                            :show-overflow-tooltip="true"

                    >
                    </el-table-column>

                    <el-table-column
                            prop="description"
                            label="模板描述"
                            align="left"
                            :show-overflow-tooltip="true"

                    >
                        <template scope="scope">
                            <div class="templateinfoDescription">
                                <div class="templateInfoDes" v-if="scope.row.description!==''">{{scope.row.description}}</div>
                                <div class="templateInfoDes" v-if="scope.row.description===''">--</div>
                            </div>

                        </template>
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="220"
                            align="center"
                    >
                        <template scope="scope">
                            <div class="templateinfoOperation">
                                <div class="templateinfoOperationBtn">
                                    <div class="btnRevise">
                                        <el-button type="warning" size="mini" icon="el-icon-view" @click="dialogFormVisible1 = true" circle></el-button>
                                    </div>
                                    <div class="btnRevise">
                                        <el-button type="info" size="mini" icon="el-icon-document-copy" @click="dialogFormVisible1 = true" circle></el-button>
                                    </div>
                                    <div class="btnRevise" v-if="items!==''" @click="reviseTemplate(scope.row.id)">
                                        <!-- <img src="../../../assets/images/fieldmanage/rivese.png" style="height: 16px;width: 16px" @click="dialogFormVisible1 = true"/> -->
                                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="dialogFormVisible1 = true" circle></el-button>
                                    </div>
                                    <div class="btnDelete">
                                        <!-- <img src="../../../assets/images/fieldmanage/delBlue.png" style="width: 16px;height: 16px" @click="deleteClick(scope.row.id,scope.row._workOderCount)" v-if="scope.row.deletable==null || scope.row.deletable" /> -->
                                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteClick(scope.row.id,scope.row._workOderCount)" v-if="scope.row.deletable==null || scope.row.deletable" circle></el-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
        </div>
        <el-dialog  :visible.sync="dialogFormVisible" title="删除模板" custom-class="templateDialog" :close-on-click-modal="false">

            <div class="templateDialogDelText">您删除的<span style="font-size: 16px;font-weight: 600">{{deleteTemplateName}}</span>模板下有<span style="font-size: 16px;font-weight: 600">{{templateOrder}}</span>个工单，需要将这些工单移动至</div>
            <el-select v-model="template" style="width: 100%;margin-bottom: 12px">
                <el-option
                        v-for="item in selectOrderList"
                        :value="item.id"
                        :key="item.id"
                        :label="item.name"
                ></el-option>
            </el-select>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="danger" @click="deleteTemplate">删 除</el-button>
            </div>


            <!-- <div>你确定删除<span style="font-weight: 600;font-size: 16px">{{items.name}}吗？</span></div>
             <div slot="footer" class="dialog-footer">
                 <el-button @click="dialogFormVisible = false">取 消</el-button>
                 <el-button type="danger" @click="deleteTemplate(items.id)">删 除</el-button>
             </div>
        -->

        </el-dialog>
        <el-dialog  :visible.sync="dialogFormVisible2" title="删除模板" custom-class="templateDialog" :close-on-click-modal="false">

            <div class="templateDialogDelText">您确定删除<span style="font-size: 16px;font-weight: 600">{{deleteTemplateName}}</span>吗？</div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="danger" @click="deleteTemplate2">删 除</el-button>
            </div>


            <!-- <div>你确定删除<span style="font-weight: 600;font-size: 16px">{{items.name}}吗？</span></div>
             <div slot="footer" class="dialog-footer">
                 <el-button @click="dialogFormVisible = false">取 消</el-button>
                 <el-button type="danger" @click="deleteTemplate(items.id)">删 除</el-button>
             </div>
        -->

        </el-dialog>

    </div>
</template>

<script>
    import Sortable from 'sortablejs'
    export default {
        name: "TemplateInfo",
        props: {
            items: {
                type: Object,
                default() {
                    return {}
                }
            },
            count: {
                type: Boolean
            },
            index:Number,
            templateList:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data() {
            return {
                dialogFormVisible: false,
                dialogFormVisible2: false,
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                oldNum: 0,
                newNum: 0,
                currList:[],
                startIndex:'',
                enterIndex:'',
                orderList:[],
                selectOrderList:[],
                deleteTemplateName:'',
                test:1,
                templateResortList:[],
                OtherTemplate:[],
                template:'',
                templateOrder:'',
                templateId:''
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getWorkOrderList()
            })
        },
        methods: {
            //获取行样式
            getRowClass(){
                return 'templateRowClass'
            },

            //获取工单模板
            getWorkOrderList(){
                this.$http.get('/api/template/list').then(res=>{
                    this.orderList=res.data.data




                })
            },
            deleteClick(orderId,num){
                console.log(orderId)
                this.templateId=orderId
                if(num===0)
                {
                    this. dialogFormVisible2=true
                    this.orderList.forEach(item=>{
                        if(item.id===orderId)
                        {
                            this.deleteTemplateName=item.name
                        }

                    })
                }
                if(num > 0)
                {

                    this. dialogFormVisible=true
                    let test=[]
                    this.orderList.forEach((item)=>{
                        console.log()
                        if(item.id!==orderId)
                            test.push(item)
                    })
                    this.orderList.forEach(item=>{
                        if(item.id===orderId)
                        {
                            this.deleteTemplateName=item.name
                            this.templateOrder=item._workOderCount
                        }

                    })
                    this.selectOrderList=test
                }
            },
            deleteTemplate(){

                console.log(this.template)
                console.log(this.templateId)
                if(this.template!=='')
                {
                    this.$http.delete('/api/template/'+this.templateId+'?newId='+this.template).then(res=>{
                        if(res.data.code==='0')
                        {
                            this.$message.success('删除工单模板成功')
                        }
                        else
                            this.$message('删除工单模板失败')
                        this.$emit('deleteTemplate')
                    })
                    this.dialogFormVisible=false
                }
                else
                    this.$message.error('请选择要移至的工单')

            },
            deleteTemplate2(){

                    this.$http.delete('/api/template/'+this.templateId).then(res=>{
                        if(res.data.code==='0')
                        {
                            this.$message.success('删除工单模板成功')
                        }
                        else
                            this.$message('删除工单模板失败')
                        this.$emit('deleteTemplate')
                    })
                    this.dialogFormVisible2=false

            },
            reviseTemplate(itemsId){
                this.$router.push(
                    {
                        path:'/addtemplate',
                        query:{
                            id:itemsId
                        }
                    }

                )
            },
            resortTemplate(){
                let _this = this;
                let el = document.querySelector('.el-table__body-wrapper tbody');
                new Sortable(el,{
                    ghostClass: 'blue-background-class',
                    animation: 200,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    handle: ".my-handle",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el.children[newIndex],
                            $oldLi = el.children[oldIndex];
                        // 先删除移动的节点
                        el.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el.insertBefore($li,$oldLi)
                        } else {
                            el.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.templateList.splice(oldIndex,1)
                        _this.templateList.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },
                });
                this.templateResortList=_this.templateList
                this.$emit('resortTemplate',this.templateResortList)
            },
            indexMethod(index){
                return index+1
            }

        },

    }
</script>

<style  lang="less">
@import "../../../assets/less/workordertemplate/templateinfo/templateinfo";
/*.templateinfo{
    position: absolute;
    transition: transfrom 1s;
}*/
 .my-handle{
     cursor: move;
 }
.blue-background-class{
    background-color: #F1F4F5;
}
.module-result-content2 {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    .result-content2 {
        flex: 1;
        position: relative;
        .el-table {
            position: absolute;
            overflow: hidden;

        }
    }
}
    .templateRowClass{
        font-family: "Arial Normal", "Arial", sans-serif;
        height: 60px;
        line-height: 60px;
    }
</style>